import { currentPatientIdSelector } from '../patient';
import DietService from './DietService';
import { setDiet } from './actions';

// HELPERS
const toRequest = (dietList, patientId) => ({
  diets: dietList,
  patientId,
});

// THUNKS
export const fetchDietAsync = () => (dispatch, getState) => {
  const state = getState();
  const patientId = currentPatientIdSelector(state);

  return dispatch(DietService.getByPatientId(patientId)).then(dietList => {
    return dispatch(setDiet(dietList));
  });
};

export const saveDietAsync = dietList => (dispatch, getState) => {
  const state = getState();
  const patientId = currentPatientIdSelector(state);

  return dispatch(DietService.create(toRequest(dietList, patientId))).then(() =>
    dispatch(setDiet(dietList)),
  );
};



// WEBPACK FOOTER //
// ./src/lib/dataLayer/diet/thunks.js